import React, { useEffect } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { listSensorOrder, sortSensors } from 'commons/src/commonFunctions';
import SensorComponent from 'commons/src/components/sensors/SensorComponent';
import { deviceTypes } from 'commons/src/constants';
import LogoDark from 'commons/src/img/logos/Airthings_Logo_Horizontal_Dark_Grey.png';
import Logo from 'commons/src/img/logos/Airthings_Logo_Horizontal_White.png';
import { getDotColor } from '../../components/tile/PublicSensorTile';
import { CurrentSensorValuesType, DeviceSensorDetailsType } from '../../models/commons';
import { Store } from '../../reducers';

interface StateProps {
    loading: boolean;
    deviceType: keyof typeof deviceTypes;
    sensorData: CurrentSensorValuesType[];
    sensorDetails: { [sensor: string]: DeviceSensorDetailsType };
    backgroundColor?: string;
}

type Props = StateProps;

export const VideoCallLiveDataComponent = ({
    loading,
    sensorDetails,
    sensorData,
    deviceType,
    backgroundColor,
}: Props): React.ReactElement => {
    useEffect(() => {
        document.body.className = 'root__meeting-background';
        return () => {
            document.body.className = '';
        };
    }, [loading]);

    const order = listSensorOrder[deviceType];
    const sortedSensors = sortSensors(sensorData, order);
    return (
        <div className={classNames('meeting-background', { 'meeting-background--white': backgroundColor === 'white' })}>
            <img
                src={backgroundColor === 'white' ? LogoDark : Logo}
                className="meeting-background__logo"
                alt="Airthings Logo"
            />
            <div className="meeting-background__sensors">
                {sortedSensors.map(sensor => {
                    const sensorDetail = sensorDetails[sensor.type];
                    const dotColor = getDotColor(sensor.value, sensorDetail);
                    return (
                        <SensorComponent
                            key={sensor.type}
                            dotColor={dotColor}
                            sensorType={sensor.type}
                            unit={(sensorDetail && sensorDetail.unit) || 'none'}
                            value={sensor.value}
                            displayStatusBar
                        />
                    );
                })}
            </div>
        </div>
    );
};

const mapStateToProps = (state: Store): StateProps => {
    const {
        publicDeviceData: { loading: deviceDataLoading, sensorDetails, deviceType, backgroundColor },
        publicDeviceSensorData: { loading: sensorDataLoading, sensorData },
    } = state;
    return {
        loading: sensorDataLoading || deviceDataLoading,
        sensorData,
        sensorDetails,
        deviceType,
        backgroundColor,
    };
};

export default connect(mapStateToProps)(VideoCallLiveDataComponent);
